export default __webpack_public_path__ + "static/media/ppc_v2.e4961a54.jpg";